export const INDUSTRY_OPTIONS = [
    { "text": " ", "value": ",01d1d722-f171-e511-80d9-3863bb36cca0"},
    { "text": "Beverages", "value": "Beverages,f7b50dd9-1707-ea11-a811-000d3a1bbde1"},
    { "text": "Bio Pharma", "value": "Bio-Pharma,e8ba8edf-44a4-e211-9a78-78e7d1620f22" },
    { "text": "Building Products", "value": "Building-Products,eaba8edf-44a4-e211-9a78-78e7d1620f22" },
    { "text": "Chemicals", "value": "Chemicals,ecba8edf-44a4-e211-9a78-78e7d1620f22"},
    { "text": "Food", "value": "Food,f7b50dd9-1707-ea11-a811-000d3a1bbde1"},
    { "text": "Paints & Coatings", "value": "Paints-and-Coatings,eeba8edf-44a4-e211-9a78-78e7d1620f22" },
    { "text": "Paper", "value": "Paper,f4ba8edf-44a4-e211-9a78-78e7d1620f22" },
    { "text": "Plastics", "value": "Plastics,f6ba8edf-44a4-e211-9a78-78e7d1620f22" },
    { "text": "Textiles", "value": "Textiles,f8ba8edf-44a4-e211-9a78-78e7d1620f22"},
    { "text": "Others", "value": "Others,01d1d722-f171-e511-80d9-3863bb36cca0" },
]